import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Send, Loader2, Clock } from "lucide-react";
import { log } from "../../utils/logger";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DigestCard() {
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/admin/emails/digest-status`, { withCredentials: true });
      setStatus(data);
    } catch (e) {
      log.warn("digest status failed", e);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const sendNow = async () => {
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/admin/emails/send-digest`, {}, { withCredentials: true });
      toast.success(`${data.message} · ${data.open_count} open ${data.open_count === 1 ? "inquiry" : "inquiries"}`);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to send digest");
    }
    setSending(false);
  };

  return (
    <div data-testid="digest-card" className="mb-6 flex flex-col gap-4 rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-5 shadow-[3px_3px_0px_var(--c-shadow)] sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border-2 border-[var(--c-border)] bg-[#1E3A8A] text-white">
          <Mail className="h-5 w-5" />
        </div>
        <div>
          <h3 className="font-heading text-base font-bold text-[var(--c-text)]">Inquiry Email Digest</h3>
          <p className="text-xs text-[var(--c-muted)]">
            {status ? (
              <>
                <span data-testid="digest-open-count" className="font-bold text-[var(--c-text)]">{status.open_count}</span> open {status.open_count === 1 ? "inquiry" : "inquiries"} &middot; sends to <span className="font-medium">{status.sent_to || "— not configured —"}</span>
              </>
            ) : "Loading…"}
          </p>
          {status && (
            <p className="mt-1 inline-flex items-center gap-1 text-[11px] text-[var(--c-muted)]">
              <Clock className="h-3 w-3" /> {status.schedule}
              {status.last_manual_sent_at && (
                <span data-testid="digest-last-sent"> &middot; Last manual send {new Date(status.last_manual_sent_at).toLocaleString()}</span>
              )}
            </p>
          )}
        </div>
      </div>
      <button
        data-testid="send-digest-button"
        onClick={sendNow}
        disabled={sending || !status?.sent_to}
        className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-[var(--c-border)] bg-[#1E3A8A] px-5 py-2.5 text-sm font-bold text-white shadow-[3px_3px_0px_var(--c-shadow)] transition-all hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0"
      >
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        {sending ? "Sending…" : "Send Digest Now"}
      </button>
    </div>
  );
}
